import styled from "@emotion/styled";
import {
  BACKGROUND_LIGHT,
  SECONDARY_GREY,
  SECONDARY_FONT,
  PRIMARY_FONT,
  PRIMARY_BLUE,
  ERROR_COLOR,
  PRIMARY_BLACK,
  QUATERNARY_GREY,
  MID_GREY,
  LIGHT_FONT,
  LIGHT_BACKGROUND,
} from "src/constants/colors";

export const ModalWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background-color: rgba(51, 51, 51, 0.6);
  backdrop-filter: blur(10px);
`;

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  height: 90vh;
  width: 90vw;
  max-width: 1200px;
  background-color: ${BACKGROUND_LIGHT};
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 0 24px;
  border-bottom: 1px solid ${SECONDARY_GREY};
  padding-bottom: 16px;
  margin-bottom: 24px;
`;

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${PRIMARY_FONT};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${SECONDARY_GREY};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export const FileViewerSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: ${BACKGROUND_LIGHT};
  border-right: 1px solid ${SECONDARY_GREY};
`;

export const FileHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid ${SECONDARY_GREY};
  background-color: ${LIGHT_BACKGROUND};
`;

export const FileName = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: ${PRIMARY_FONT};
`;

export const FilePreview = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
`;

export const FileIcon = styled.div`
  width: 64px;
  height: 64px;
  background-color: ${PRIMARY_BLUE};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    color: ${LIGHT_FONT};
    font-size: 12px;
    font-weight: bold;
  }
`;

export const PdfControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 12px 24px;
  border-top: 1px solid ${QUATERNARY_GREY};
  background-color: ${PRIMARY_BLACK};
  color: ${LIGHT_FONT};
  font-size: 14px;
`;

export const ZoomControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  button {
    width: 24px;
    height: 24px;
    border: 1px solid ${MID_GREY};
    background-color: transparent;
    color: ${LIGHT_FONT};
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: ${QUATERNARY_GREY};
    }
  }
`;

export const RenameSection = styled.div`
  width: 400px;
  padding: 32px;
  background-color: ${BACKGROUND_LIGHT};
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
  max-height: 100%;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: ${ERROR_COLOR};
  font-family: ${PRIMARY_FONT};
`;

export const DropdownWrapper = styled.div`
  position: relative;
`;

export const DropdownSelect = styled.select`
  width: 100%;
  padding: 12px 16px;
  padding-right: 40px;
  font-size: 16px;
  border: 2px solid ${PRIMARY_BLUE};
  border-radius: 4px;
  background-color: ${BACKGROUND_LIGHT};
  color: ${PRIMARY_BLACK};
  appearance: none;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${PRIMARY_BLUE};
  }

  option {
    padding: 8px;
  }
`;

export const DropdownIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: ${PRIMARY_BLUE};

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const HelpText = styled.div`
  font-size: 14px;
  color: ${MID_GREY};
  line-height: 1.5;
  font-family: ${SECONDARY_FONT};
`;

export const FileNameInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FileNameLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${PRIMARY_FONT};
  font-family: ${PRIMARY_FONT};
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-top: auto;
`;
